import { render, staticRenderFns } from "./DatasetGroupSelectorTree.vue?vue&type=template&id=54c2489b&scoped=true"
import script from "./DatasetGroupSelectorTree.vue?vue&type=script&lang=js"
export * from "./DatasetGroupSelectorTree.vue?vue&type=script&lang=js"
import style0 from "./DatasetGroupSelectorTree.vue?vue&type=style&index=0&id=54c2489b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2489b",
  null
  
)

export default component.exports